var _desc, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightTheme = function SvgLightTheme(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 29,
    viewBox: "0 0 30 29"
  }, props), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Generated with Avocode.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-469a9571-041a-4109-901b-3f9c92358310)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M15.08 8.01a6.59 6.59 0 1 0 0 13.179 6.59 6.59 0 0 0 0-13.179"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-469a9571-041a-4109-901b-3f9c92358310)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M15.08 4.84c.676 0 1.225-.549 1.225-1.225V1.523a1.224 1.224 0 0 0-2.449 0v2.092c0 .676.548 1.224 1.224 1.224"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-469a9571-041a-4109-901b-3f9c92358310)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M15.08 24.36c-.676 0-1.224.548-1.224 1.224v2.092a1.224 1.224 0 0 0 2.449 0v-2.092c0-.676-.549-1.224-1.225-1.224"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-469a9571-041a-4109-901b-3f9c92358310)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M28.157 13.375h-2.092a1.224 1.224 0 1 0 0 2.449h2.092a1.224 1.224 0 0 0 0-2.449"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-469a9571-041a-4109-901b-3f9c92358310)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M5.32 14.6c0-.677-.548-1.225-1.224-1.225H2.004a1.224 1.224 0 1 0 0 2.449h2.092c.676 0 1.224-.548 1.224-1.224"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-469a9571-041a-4109-901b-3f9c92358310)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M22.847 8.057c.314 0 .627-.12.866-.359l1.48-1.479a1.224 1.224 0 1 0-1.732-1.731l-1.48 1.479a1.224 1.224 0 0 0 .866 2.09"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-469a9571-041a-4109-901b-3f9c92358310)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "m6.448 21.501-1.48 1.48A1.224 1.224 0 0 0 6.7 24.71l1.479-1.479a1.224 1.224 0 1 0-1.731-1.731"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-469a9571-041a-4109-901b-3f9c92358310)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M23.713 21.501a1.224 1.224 0 1 0-1.731 1.732l1.479 1.479c.239.239.552.358.866.358s.626-.12.865-.358a1.224 1.224 0 0 0 0-1.732z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-469a9571-041a-4109-901b-3f9c92358310)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M6.448 7.698a1.22 1.22 0 0 0 1.73 0 1.224 1.224 0 0 0 0-1.731L6.7 4.487A1.224 1.224 0 1 0 4.968 6.22z"
  }))));
};
export default SvgLightTheme;